import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ModuleService from '../../services/module.service';
import './style.css';

const linkComp = ({ colorSchema, location })=> link => (
  <li key={link.path} className={colorSchema}>
    <a
      target="_blank"
      href={link.path}
      className={`three-dots ${link.path === location.pathname ? 'tc tc_act' : 'tc tc_dis'}`}
    >{link.name}
    </a>
  </li>
);

const Navigation = ({ cssClass, links, location, colorSchema, match, customLinks, youtube, countUnreadMessage, vimeo }) => (
  <div className={cssClass || 'leftw'}>
    <div className="leftinner boxs">
      <ul className="Blog_link boxs Blog_linkgrn navigation">

        {links.map((link) => {
          switch (link.moduleType) {
            case ModuleService.TYPE_LINK:
              return customLinks.map(linkComp({ location }));
            case ModuleService.TYPE_YOUTUBE:
              return youtube.map(linkComp({ location }));
            case ModuleService.TYPE_VIMEO:
              return vimeo.map(linkComp({ location }));
            default:
              return (
                <li key={link.path} className={colorSchema}>
                  <Link
                    to={link.path}
                    className={`${link.path === location.pathname || link.path === match.path ? 'tc tc_act' : 'tc tc_dis'} navigation-hidden-over-block`}
                  >{link.name}
                    {link.module === ModuleService.TYPE_MESSAGE && countUnreadMessage ?
                      <span className="msgnumber">{countUnreadMessage}</span> : ''}
                  </Link>
                </li>);
          }
        })}
      </ul>
    </div>
  </div>
);

Navigation.propTypes = {
  cssClass: PropTypes.string,
  links: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/navigation/Navigation.jsx